export default "__VITE_ASSET__ab6ayXBo__"